import React from 'react';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import  './CompinedStyle.less';

const RenderTextArea = ({ input, rows, cols, label, meta: { touched, error } }) =>  //eslint-disable-line react/prop-types
   (
      <FormGroup>
         <FormGroup controlId="formControlsTextarea" >
            <ControlLabel>{label}</ControlLabel>
            <FormControl
               rows={rows ? rows : ''}
               cols={cols ? cols : ''}
               {...input}
               componentClass="textarea"
               placeholder={label} />
         </FormGroup>
         {touched && error && <span
            className="input-validation-error"
         >{error}</span>}
      </FormGroup>
   );

export default RenderTextArea;



/** WEBPACK FOOTER **
 ** ./src/components/FormTemplate/TextareaControl.js
 **/